import { createAction, props } from '@ngrx/store';


export const ActionTypes = {
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  CLOSE_ALL_MODALS: 'CLOSE_ALL_MODALS'
};

export interface ModalProps {
  data?: unknown;
  itemName?: string;
  onModalDismiss?: (...args: unknown[]) => void;
  onModalSubmit?: (...args: unknown[]) => void;
}

export const openModal = createAction(
  ActionTypes.OPEN_MODAL,
  props<{ modalName: string; props?: ModalProps }>()
);

export const closeModal = createAction(ActionTypes.CLOSE_MODAL, props<{ modalName: string }>());

export const closeAllModals = createAction(ActionTypes.CLOSE_ALL_MODALS);

